import React from 'react';
import axios from "axios";
import {useNavigate} from "react-router-dom";

interface HeaderProps {
    toggleSidebar: () => void;
    isNavBarMinimized: boolean;
}

const Header: React.FC<HeaderProps> = ({ toggleSidebar, isNavBarMinimized }) => {

    const API_URL = `${process.env.REACT_APP_API_URL}`

    const navigate = useNavigate()


    const logout = async () => {
        await axios.get(`${API_URL}/logout`, {withCredentials: true})
            .then(response => {
                if(response.status === 200)
                {
                    navigate('/admin')
                }
            })
            .catch(error => {

            })
    }

    return (
        <div className="bg-white p-2 py-4 flex justify-between h-20 border-b border-gray-200 sticky top-0 z-50">
            <div className="flex space-x-2 items-center">
                <div onClick={toggleSidebar} className="p-2 border border-gray-200 rounded visable md:hidden cursor-pointer">
                    {isNavBarMinimized ?
                            <svg className="h-6 fill-gray-400" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M18.8,16l5.5-5.5c0.8-0.8,0.8-2,0-2.8l0,0C24,7.3,23.5,7,23,7c-0.5,0-1,0.2-1.4,0.6L16,13.2l-5.5-5.5 c-0.8-0.8-2.1-0.8-2.8,0C7.3,8,7,8.5,7,9.1s0.2,1,0.6,1.4l5.5,5.5l-5.5,5.5C7.3,21.9,7,22.4,7,23c0,0.5,0.2,1,0.6,1.4 C8,24.8,8.5,25,9,25c0.5,0,1-0.2,1.4-0.6l5.5-5.5l5.5,5.5c0.8,0.8,2.1,0.8,2.8,0c0.8-0.8,0.8-2.1,0-2.8L18.8,16z"></path>
                                </g>
                            </svg>
                    :
                        <svg className="h-6 stroke-gray-500" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path d="M4 7L7 7M20 7L11 7" strokeWidth="1.5" strokeLinecap="round"></path>
                                <path d="M20 17H17M4 17L13 17" strokeWidth="1.5" strokeLinecap="round"></path>
                                <path d="M4 12H7L20 12" strokeWidth="1.5" strokeLinecap="round"></path>
                            </g>
                        </svg>
                    }
                </div>
                <div className="bg-gray-300 rounded-full w-10 h-10"></div>
                <div className="flex flex-col items-center">
                    <span className="font-semibold">Administrator</span>
                    <span className="text-gray-500 text-sm self-start">Admin</span>
                </div>
            </div>
            <div className="flex items-center">
                <button onClick={logout} className="admin-btn">Logout</button>
            </div>
        </div>
    );
};

export default Header;